import { render, staticRenderFns } from "./examinxqtwo.vue?vue&type=template&id=79d3b998&scoped=true"
import script from "./examinxqtwo.vue?vue&type=script&lang=js"
export * from "./examinxqtwo.vue?vue&type=script&lang=js"
import style0 from "./examinxqtwo.vue?vue&type=style&index=0&id=79d3b998&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3b998",
  null
  
)

export default component.exports